package io.horion.cv.components.forms

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.minWidth
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.breakpoint.displayIfAtLeast
import com.varabyte.kobweb.silk.style.breakpoint.displayUntil
import com.varabyte.kobweb.silk.style.toModifier
import io.horion.cv.viewModel.CvViewModel
import io.horion.cv.api.datasource.cv.Learn
import io.horion.cv.components.widgets.FormActionButtons
import io.horion.cv.components.widgets.PeriodeSelector
import io.horion.cv.components.widgets.RichTextDescription
import io.horion.cv.components.widgets.TextFormField
import io.horion.cv.models.CourseState
import io.horion.cv.styles.ActivityFullWidthFieldStyle
import io.horion.cv.styles.ActivityHalfWidthFieldStyle
import io.horion.cv.styles.CourseEqualFieldStyle
import io.horion.cv.styles.CourseFieldsRowStyle
import io.horion.cv.styles.CourseFormStyle
import org.jetbrains.compose.web.css.px

@Composable
fun CourseForm(
    index: Int,
    state: CourseState,
    cvViewModel: CvViewModel,
    onDelete: () -> Unit,
    onComplete: () -> Unit
) {
    val updateVM = {
        val dateValue =
            if (state.isOngoing) {
                "En cours"
            } else {
                "${state.mois}-${state.annee}"
            }

        val updatedLearn = Learn(
            label = state.cours,
            started = dateValue,
            ended = dateValue,
            description = state.description
        )

        cvViewModel.updateCourse(index, updatedLearn)
    }

    Column(
        modifier = CourseFormStyle.toModifier()
    ) {
        Column(
            modifier = CourseFieldsRowStyle.toModifier()
        ) {
            Box(
                modifier = CourseEqualFieldStyle.toModifier()
            ) {
                TextFormField(
                    label = "Cours",
                    value = state.cours,
                    onValueChange = {
                        state.cours = it
                        updateVM()
                    },
                    modifier = Modifier
                        .fillMaxWidth()
                        .minWidth(0.px)
                )
            }

            Box(
                modifier = CourseEqualFieldStyle.toModifier()
            ) {
                PeriodeSelector(
                    month = state.mois,
                    year = state.annee,
                    isOngoing = state.isOngoing,
                    onMonthChange = {
                        state.mois = it
                        updateVM()
                    },
                    onYearChange = {
                        state.annee = it
                        updateVM()
                    },
                    onOngoingChange = {
                        state.isOngoing = it

                        if (it) {
                            state.mois = ""
                            state.annee = ""
                        }

                        updateVM()
                    }
                )
            }
        }

        RichTextDescription(
            label = "Description",
            value = state.description,
            onValueChange = {
                state.description = it
                updateVM()
            },
            modifier = Modifier
                .fillMaxWidth()
                .minWidth(0.px)
        )

        FormActionButtons(
            onDelete = onDelete,
            onComplete = onComplete
        )
    }
}